export const FREE_PLAN_NAME = 'free';
export const SUPPLIER_FREE_PLAN_NAME = 'supplier_free';
export const PLANNER_FREE_PLAN_NAME = 'planner_free';
export const FREE_PLAN_NAMES: string[] = [
  FREE_PLAN_NAME,
  SUPPLIER_FREE_PLAN_NAME,
  PLANNER_FREE_PLAN_NAME,
];
export const PRO_PLAN_NAME = 'pro';
export const ENTERPRISE_PLAN_NAME = 'enterprise';
export const PRISMM = 'prismm';

export function getFreePlanNameByClientType(clientType: string): string {
  return clientType === 'supplier'
    ? SUPPLIER_FREE_PLAN_NAME
    : PLANNER_FREE_PLAN_NAME;
}

export const PLANNER_PRO_MIGRATED_PLAN_NAME = 'planner_pro_migrated';
export const SUPPLIER_PRO_MIGRATED_PLAN_NAME = 'supplier_pro_migrated';
export const PLANNER_PREMIUM_PLAN_NAME = 'planner_premium';
export const SUPPLIER_PREMIUM_PLAN_NAME = 'supplier_premium';

const MIGRATED_TO_PREMIUM_PLAN_NAME: Record<string, string> = {
  [PLANNER_PRO_MIGRATED_PLAN_NAME]: PLANNER_PREMIUM_PLAN_NAME,
  [SUPPLIER_PRO_MIGRATED_PLAN_NAME]: SUPPLIER_PREMIUM_PLAN_NAME,
};

export function getDisplayCurrentPlanName(planName: string): string {
  return MIGRATED_TO_PREMIUM_PLAN_NAME[planName] ?? planName;
}

export const FREE_BASE_PRICE = 0;
export const PRO_BASE_PRICE = 199;

export const FREE_PLAN_DETAILS = [
  '1 User account',
  '1 Event per year',
  '25 Attendees per attendee list',
  '5 Diagrams per event',
  '5 Collaborators per event',
];

export const PRO_PLAN_DETAILS = [
  '1 User account',
  '12 Events per year',
  '150 Attendees per attendee list',
  '5 Diagrams per event',
  'Unlimited collaborators',
];
